import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '@env/environment';
import { SeoService } from '@services';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'Outlet portal';

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: object,
        private cookieService: CookieService,
        private seoService: SeoService,
    ) {}

    ngOnInit() {
        this.checkVersion();

        if (environment.needProtect) {
            this.seoService.setMetaData('name', 'robots', 'noindex, nofollow');
        }
        if (environment.production) {
            this.setCookieBotScripts();
        }
        this.setDynamicScripts();
    }

    setDynamicScripts() {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                const dynamicScripts = [];
                if (environment.production) {
                    if (environment.needBugherd) {
                        dynamicScripts.push('https://www.bugherd.com/sidebarv2.js?apikey=rbppniueig0xkrthul5jwq');
                    }
                    dynamicScripts.push('https://jscloud.net/x/13391/inlinks.js');
                }

                for (const value of dynamicScripts) {
                    const node = this.document.createElement('script');
                    node.src = value;
                    node.type = 'text/javascript';
                    node.async = true;
                    this.document.getElementsByTagName('head')[0].appendChild(node);
                }
            }, 5000);
        }
    }

    private checkVersion() {
        const vCookie = this.cookieService.get('version');

        if (!vCookie || vCookie !== environment.version) {
            this.cookieService.set('version', environment.version);

            const cookies = this.cookieService.getAll();
            let keys = Object.keys(cookies);
            keys = keys.filter((k) => k !== 'version');
            keys.forEach((key) => {
                this.cookieService.delete(key);
            });
        }
    }

    setCookieBotScripts() {
        if (isPlatformBrowser(this.platformId) && environment.production) {
            const node = this.document.createElement('script');
            node.id = 'Cookiebot';
            node.src = 'https://consent.cookiebot.com/uc.js';
            node.dataset.cbid = 'bffd9af3-2b64-450f-b0c6-a29d81c86a11';
            node.dataset.blockingmode = 'manual';
            node.type = 'text/javascript';
            node.onload = this.cookieConsentHandler.bind(this);
            this.document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    cookieConsentHandler() {
        window.addEventListener(
            'CookiebotOnAccept',
            (event: any) => {
                const node = this.document.createElement('script');
                node.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KZWL6RR';
                node.type = 'text/javascript';
                this.document.getElementsByTagName('head')[0].appendChild(node);
            },
            false,
        );
    }
}
